import type { ReactNode } from "react";

/**
 * Break-glass. The card form is hidden rather than unmounted while a submit is
 * in flight or has succeeded — unmounting it would tear down Stripe's card
 * iframes and make the customer re-key their number. ui-core has no
 * "hidden but still mounted" primitive (its components either render or don't),
 * and the form column's fixed width has no width token.
 */
export function CreditCardsFormPane({
  visible,
  children,
}: {
  visible: boolean;
  children: ReactNode;
}) {
  return (
    <div className={visible ? "w-[608px]" : "hidden w-[608px]"}>{children}</div>
  );
}
